/**
 * SmartLink Nigeria Brand Assets
 * Uses /logo.png directly from the public directory without any fallback or vector.
 */

export const DEFAULT_LOGO_URL = "/logo.png";
export const PNG_LOGO_URL = "/logo.png";
export const DEFAULT_FAVICON_URL = "/favicon.png";
export const DEFAULT_APP_ICON_URL = "/icon-192.png";
